import React, { Component } from 'react';
import { Route } from 'react-router';
import { Layout } from './components/Layout';
import { Home } from './components/Home';
import { Client } from './components/Client';
import Preloader from './components/Preloader';
import 'shared/fonts.scss';

import { fonts, images } from './constants/constants';

export default class App extends Component {
    static displayName = App.name;

    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
        };
    }

    // Preloader calls this once every asset has loaded (or failed) — before
    // its 2.5s-minimum hold and fade-out, so the routes mount underneath and
    // the branded loading screen fades out over the live app.
    handleLoadingComplete = () => {
        this.setState({ isLoading: false });
    }

    render() {
        return (
            <Layout>
                {
                    !this.state.isLoading &&
                    <>
                        <Route exact path='/' component={Home} />
                        <Route path='/client' component={Client} />
                    </>
                }
                <Preloader imagesToLoad={images} fontsToLoad={fonts} onComplete={this.handleLoadingComplete} />
            </Layout>
        );
    }
}
